module.exports = __webpack_public_path__ + "static/media/times-octagon.ea67c42f.svg";